import { render, staticRenderFns } from "./CustomerGroupsSaveForm.vue?vue&type=template&id=76427c50"
import script from "./CustomerGroupsSaveForm.vue?vue&type=script&lang=js"
export * from "./CustomerGroupsSaveForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupsSaveForm.vue?vue&type=style&index=0&id=76427c50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports